/**
 * The API reference is served by the API (backend cmd/api/main.go /docs),
 * which in production lives on its own origin (VITE_API_URL). Without an
 * absolute API origin there is no reachable URL to link, so return null.
 */
export function apiDocsUrl(): string | null {
    const base = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
    return /^https?:\/\//.test(base) ? `${base}/docs` : null;
}
